import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "./ui/dialog";

import { decryptData } from "../utils/EncriptionStore";

const SaveTemplateModal = ({
  columns,
  source_table,
  schema,
  onSave,
  trigger,
}) => {
  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();
  const [open, setOpen] = useState(false);
  const [templateName, setTemplateName] = useState("");
  // const [templateDescription, setTemplateDescription] = useState("");

  console.log("Columns recieved from parent:", columns);

  const handleSave = async () => {
    if (!templateName.trim()) {
      toast.error("Template name is required");
      return;
    }

    const selectedColumnNames = Array.isArray(columns)
      ? columns
          .filter((col) => col.selected)
          .sort((a, b) => a.selectedAt - b.selectedAt) // ensure order of selection
          .map((col) => col.name)
      : [];

    console.log("Selected columns in modal:", selectedColumnNames); // Log selected columns

    const template = {
      name: templateName,
      columns: selectedColumnNames,
      source_table: source_table,
      schema: schema,
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    };

    if (onSave) {
      await onSave(template); // Wait for save to finish
    }

    setTemplateName("");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || <Button variant="default">Save Template</Button>}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Save Template</DialogTitle>
          <DialogDescription>
            Create a new template with your selected columns. Fill out the
            details below.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <label
              htmlFor="templateName"
              className="text-right font-medium col-span-1"
            >
              Name
            </label>
            <Input
              id="templateName"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              className="col-span-3"
              placeholder="My Template"
              required
            />
          </div>

          <div className="grid grid-cols-4 items-center gap-4">
            <div className="text-right font-medium col-span-1">Columns</div>
            <div className="col-span-3">
              <p className="text-sm text-gray-500">
                {columns.filter((col) => col.selected).length} columns selected
              </p>
            </div>
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button onClick={handleSave}>Save Template</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaveTemplateModal;
